import { useEffect, useState } from 'react';
import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { toast } from 'react-toastify';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { InvoiceBase, InvoiceBaseUpdateRequest, InvoiceItem } from '../../../types/Invoice';
import { useParams } from 'react-router';
import { useLoading } from '../../../context/loadingContext';
import { InvoiceFormContainer } from './InvoiceFormContainer';
import { filterObjectFromEmptyString } from '../../../utils/functions/data.functions';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { paths } from '../../RouterContainer';
import { useAuth } from '../../../context/AuthContext';
import { useCurrentCompany } from '../../../hooks/useCompany';

/**
 * Page component represents form with creating new invoice.
 */
export const InvoiceUpdatePage = () => {
  const { id: invoiceId } = useParams();
  const { company } = useCurrentCompany();
  const { user } = useAuth();
  const { startLoading, stopLoading } = useLoading();
  const [data, setData] = useState<InvoiceBase | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      { path: `${paths.INVOICES}`, name: 'navigation.documents' },
      { path: `${paths.INVOICE}/${invoiceId}`, name: 'navigation.document-detail' },
    ]);
  }, []);

  /**
   * Loads document
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.ACCOUNTING_DOCUMENT_ITEM}?id=${invoiceId}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles create action for new invoice form submit.
   * Uses team create API.
   * @param values form data
   */
  const handleSubmit = async (data: InvoiceBaseUpdateRequest, hideInfoSuccess?: boolean) => {
    // potřebuju id pro edit/delete položek před odesláním, ale pak ho potřebuju odebrat
    // odebrat id novým záznamů, ale nechat uuid už vytvořeným záznamům
    const _invoiceItems = data.items.map((item: InvoiceItem) => {
      // TODO lepší způsob jak odlišit id a uuid?
      if (item.id && item.id.length > 5) return item;
      return { ...item, id: undefined };
    });
    // filters data from values where are only empty strings
    const filteredData = filterObjectFromEmptyString(data);
    startLoading();
    try {
      let req = '';
      if (user?.fullName) req += `?fullName=` + user?.fullName;
      if (user?.phoneNumber) req += `&phoneNumber=` + user?.phoneNumber;
      if (company?.codeBookItemsUseCode)
        req += `&codeBookItemsUseCode=` + company?.codeBookItemsUseCode;
      if (company?.maxDecimalNumUnitPrice)
        req += `&maxDecimalNumUnitPrice=` + company?.maxDecimalNumUnitPrice;
      const response = await http.apiPut({
        url: `${apiUrl.ACCOUNTING_DOCUMENT_UPDATE}${req}`,
        data: { ...filteredData, items: _invoiceItems },
      });
      if (response?.status === 200) {
        if (!hideInfoSuccess) toast.success('Success!');
        stopLoading();
        fetchData();
      }
      if (!response) stopLoading();
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (!data) return <>Loader...</>;
  return <InvoiceFormContainer data={data} onSubmit={handleSubmit} mutate={fetchData} />;
};
